module.exports = __webpack_public_path__ + "static/blog-03-93b146cca2ee214e8c9d1df2d6937d65.jpg";